'use strict';

var Column = require('./Column.js');
var Row = require('./Row.js');

const Flex = {
    Row: Row.Row,
    Column: Column.Column,
};

exports.Flex = Flex;
//# sourceMappingURL=index.js.map
